define('wathirdparty', ['jquery'], function ($) {

  var wathirdparty = {
    _document: $(document),

    squarelovinContainer: $('.squarelovin-container'),
    squarelovinHeadlineContainer: $('.squarelovin[style*="opacity"]'),
    squarelovinBackgroundClassName: 'squarelovin-overlay-background',
    squarelovinCloseBtnClassName: 'squarelovin-overlay-close-btn',

    sqaurelovinWhiteOverlayBugFix: function sqaurelovinWhiteOverlayBugFix() {
      var _this = this;

      if (!this.squarelovinContainer.length || !this.squarelovinHeadlineContainer.length) return;

      var setSQLVisibility = setInterval(function () {
        SQLElements = _this.squarelovinContainer.children();
        SQLItems = _this.squarelovinContainer.children().find('.squarelovin-stream-item');
        if (SQLItems.length > 0) {
          clearInterval(setSQLVisibility);
          _this.squarelovinHeadlineContainer.css({ opacity: 1 });
          $('.squarelovin-stream-container.product-stream').addClass('item-length-' + SQLItems.length);
          //this.setKueperAttributes(SQLElements);
        }
      }, 500);
    },
    squarelovinClose: function squarelovinClose() {
      var _this2 = this;

      if (!this.squarelovinContainer.length) return;

      this._document.on('click', this.squarelovinContainer, function (e) {
        var setSQLCloseEvent = setInterval(function () {

          if ($('.' + _this2.squarelovinBackgroundClassName).length) {
            _this2._document.on('click', '.' + _this2.squarelovinBackgroundClassName, function (e) {
              if (!$(e.target).is('.' + _this2.squarelovinBackgroundClassName + ' *')) {
                $('.' + _this2.squarelovinCloseBtnClassName).trigger('click');
              }
            });
            clearInterval(setSQLCloseEvent);
          }
        }, 500);
      });
    },
    setKueperAttributes: function setKueperAttributes(SQLElements) {

      var getSQLChilds = setInterval(function () {
        var SQLChilds = SQLElements.find('.squarelovin-stream-item');
        if (SQLChilds.length > 1) {
          clearInterval(getSQLChilds);
          SQLChilds.each(function (i, el) {
            var self = $(el);
            self.attr({
              "data-name": self.find('.squarelovin-user-info small:eq(0)').text() + ' ' + self.find('.squarelovin-user-info strong').text(),
              "data-list": window.SQLStreamName,
              "data-creative": "Product",
              "data-position": i + 1,
              "data-kviewed": "false"
            });
          });
        }
      }, 100);
    },
    init: function init() {
      this.sqaurelovinWhiteOverlayBugFix();
      this.squarelovinClose();
    }
  };

  return wathirdparty;
});

